import { __assign } from "tslib";
import _get from 'lodash/get';
var generateFilterIdentifier = function (filter) {
    var filterWithExplicitArchive = _getFilterWithExplicitArchive(filter);
    var filterWithSortedParticipants = _getFilterWithSortedParticipants(filterWithExplicitArchive);
    var sortedFilterArray = _getSortedArrayFromObject(filterWithSortedParticipants);
    return JSON.stringify((sortedFilterArray));
};
function _getFilterWithExplicitArchive(filter) {
    if (_get(filter, 'isArchived') === undefined) {
        return __assign(__assign({}, filter), { isArchived: false });
    }
    return filter;
}
function _getFilterWithSortedParticipants(filter) {
    if (filter.participantIds) {
        filter.participantIds.sort();
    }
    return filter;
}
function _getSortedArrayFromObject(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (key) { return ([key, obj[key]]); });
}
export { generateFilterIdentifier };
